import Cookies from 'js-cookie';

// cookie lerdeki değişken ismi
const TOKEN_KEY = "jwtToken";


// Token'ı HTTPOnly cookie'ye kaydet
export const setToken = (token: string) => {
  Cookies.set(TOKEN_KEY, token, { expires: 30, secure: false, httpOnly: false });
};

// Token'ı cookie'den oku
export const getToken = (): string | undefined => {
  return Cookies.get(TOKEN_KEY);
};

// Token'ı cookie'den sil
export const removeToken = () => {
  Cookies.remove(TOKEN_KEY);
};
